import { Request } from 'express';
import { ipKeyGenerator } from 'express-rate-limit';

export function getIpFromRequest(req: Request): string {
  const xff = (req.headers['x-forwarded-for'] as string | undefined) ?? '';
  const forwarded = xff.split(',')[0]?.trim();

  const stripPort = (ip: string) => ip.replace(/:\d+$/, '');

  if (req.ip) return stripPort(req.ip);
  if (forwarded) return stripPort(forwarded);
  return '127.0.0.1';
}

/** ipv6Subnet: false disables subnet masking, number e.g. 64 applies /64 masking */
export function ipKeyGeneratorFromReq(req: Request, ipv6Subnet: number | false = 64): string {
  const ip = getIpFromRequest(req);
  return ipKeyGenerator(ip, ipv6Subnet);
}
